module.exports = __webpack_public_path__ + "img/Bluparadise_Valencia_Nuria_Daviu_WEB-082.bdb3614e.jpg";